import { FormatedField, FormatedFields, UnknownField } from "../types/fields.types";

export const findField = (fields: FormatedFields | UnknownField, fieldToSearch: string) => {
    return fields.find((field: FormatedField) => field.field === fieldToSearch);
};

export const findFieldGroup = (fields: FormatedFields, fieldToSearch: string, options?: {fallbackHeaderName?: string}) => {
    const groupName: string | undefined = fields.find((f) => f.field === fieldToSearch)?.settings?.group;
    const groupField = fields.find((f) => f?.field === groupName);
  
    if (!groupField && groupName) return makeFieldGroup(groupName, options?.fallbackHeaderName);
    return groupField;
}

const makeFieldGroup = (groupName: string, fallbackHeaderName?: string): FormatedField => {
    return {
        field: groupName,
        headerName: fallbackHeaderName ?? groupName.split("_").join(" "),
        settings: {
            interface:"group-raw",
            isGroup: true,
            type: "alias",
            hidden: false
        }
    }
}